/* RestoreSummaryRenderer.js */

"use strict";

const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const _ = require("lodash");

class RestoreSummaryRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("restore-summary-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;
        this._createElements();
        this._registerListeners();
    }

    _createElements() {
        this._titlePanel = this._createPanel("h2", "summary-title");
        this._errorLabel = this._createPanel("div", "error-label");
        this._errorLabel.innerText = "Restore failed with error: ";
        this._successLabel = this._createPanel("div", "success-label");
        this._successLabel.innerText = "The selected backup has been successfully restored.";
        this._buttonBar = this._createPanel("div", "summary-buttons");
        this._okButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
        });
    }

    _createPanel(elementType, className) {
        const panel = document.createElement(elementType);
        panel.classList.add(className);
        return panel;
    }

    _registerListeners() {
        this._okButton.on("UserClick", this._onOkClick.bind(this));
    }

    async shutdown() {
        this._unregisterListeners();
        await this._okButton.shutdown();
    }

    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._appendChildren();
                this._displaySummary();
            }
            resolve();
        });
    }

    _appendChildren() {
        this._rootElem.appendChild(this._titlePanel);
        this._rootElem.appendChild(this._errorLabel);
        this._rootElem.appendChild(this._successLabel);
        this._rootElem.appendChild(this._buttonBar);
        this._buttonBar.appendChild(this._okButton.renderer.rootElement);
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    _unregisterListeners() {
        this._okButton.removeAllListeners("UserClick");
    }

    _onOkClick() {
        this._model.sendOk();
    }

    _setTitle() {
        let title = "Restore Devices from Backups";

        this._titlePanel.innerText = title;
    }

    _displaySummary() {
        this._setTitle();

        if (this._model.restoreResults.errorMsg) {
            this._errorLabel.classList.remove("hidden");
            this._successLabel.classList.add("hidden");
            this._errorLabel.innerText = this._model.restoreResults.errorMsg;
            return;
        }

        const {failureCount} = this._model.restoreResults.summary;

        if (_.isNumber(failureCount) && failureCount > 0) {
            this._errorLabel.classList.remove("hidden");
            this._successLabel.classList.add("hidden");

            const restoreResults = this._model.restoreResults;

            for (const targetKey in restoreResults.targetErrors) {
                this._errorLabel.innerText += restoreResults.targetErrors[targetKey];
            }
        } else {
            this._errorLabel.classList.add("hidden");
            this._successLabel.classList.remove("hidden");
        }
    }

    _clearChildren(element) {
        while (element.firstChild) {
            element.firstChild.remove();
        }
    }

    _createSpan(text) {
        const span = document.createElement("span");
        span.innerText = text;
        return span;
    }
}

module.exports = RestoreSummaryRenderer;
